<template>
  <div>
    <div v-html="message"></div>
  </div>
</template>

<script>
module.exports = {
  name: "example-component",
  props: {
    username: {
      type: String,
      default: "Utilisateur",
    },
  },
  data: function () {
    return {
      message: '',
    };
  },
};
</script>

<style scoped lang="scss">
span {
  color: #555;
}
</style>